
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"teaser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"object_teaser"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subHeadline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"arrangement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalImages"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"imagesTeaser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalImages"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"imagesBackground"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalImages"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalImages"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"imageBackgroundInverted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalFiles"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalLinks"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"widthBase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthSM"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthMD"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthLG"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthXL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthBaseSecond"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthSMSecond"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthMDSecond"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthLGSecond"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthXLSecond"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthBaseOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthSMOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthMDOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthLGOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthXLOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthBaseOffsetAfter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthSMOffsetAfter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthMDOffsetAfter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthLGOffsetAfter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthXLOffsetAfter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stylingHeadline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clickBehavior"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":811}};
    doc.loc.source = {"body":"fragment teaser on object_teaser {\n    id\n    headline\n    subHeadline\n    intro\n    text\n    arrangement\n    images {\n        ...generalImages\n    }\n    imagesTeaser {\n        ...generalImages\n    }\n    imagesBackground {\n        ...generalImages\n    }\n    icon {\n        ...generalImages\n    }\n    imageBackgroundInverted\n    files {\n        ...generalFiles\n    }\n    links {\n        ...generalLinks\n    }\n    widthBase\n    widthSM\n    widthMD\n    widthLG\n    widthXL\n    widthBaseSecond\n    widthSMSecond\n    widthMDSecond\n    widthLGSecond\n    widthXLSecond\n    widthBaseOffset\n    widthSMOffset\n    widthMDOffset\n    widthLGOffset\n    widthXLOffset\n    widthBaseOffsetAfter\n    widthSMOffsetAfter\n    widthMDOffsetAfter\n    widthLGOffsetAfter\n    widthXLOffsetAfter\n    stylingHeadline\n    clickBehavior\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["teaser"] = oneQuery(doc, "teaser");
        
